





















import { GeekInfo, News, OpportunitiesNews } from '@/components/dashboard';
import { Geek } from '@/models';
import Vue from 'vue';

export default Vue.extend({
  name: 'BasicDashboardView',
  components: {
    GeekInfo,
    News,
    OpportunitiesNews,
  },
});
